import { render, staticRenderFns } from "./VesselType.vue?vue&type=template&id=1141efb0"
import script from "./VesselType.vue?vue&type=script&lang=js"
export * from "./VesselType.vue?vue&type=script&lang=js"
import style0 from "./VesselType.vue?vue&type=style&index=0&id=1141efb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports